import { createContext, useRef } from "react";

export const CcRefContext = createContext();

const CcRefProvider = ({ children }) => {
  const ccRef = useRef(null);
  return (
    <CcRefContext.Provider value={{ ccRef }}>{children}</CcRefContext.Provider>
  );
};

export default CcRefProvider;
